import { render, staticRenderFns } from "./alarms-list-row-instructions-icon.vue?vue&type=template&id=7150a5b4&"
import script from "./alarms-list-row-instructions-icon.vue?vue&type=script&lang=js&"
export * from "./alarms-list-row-instructions-icon.vue?vue&type=script&lang=js&"
import style0 from "./alarms-list-row-instructions-icon.vue?vue&type=style&index=0&id=7150a5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports